import { HiverAxios } from 'h-commons';

export const getAccountRefreshData = (email) => new Promise((resolve, reject) => {
    HiverAxios({
        url: '/gx/ext/accountRefresh',
        type: 'post',
        params: { email },
        callback: resp => resolve(resp.data),
        onfail: err => reject(err)
    })
});